import { render, staticRenderFns } from "./practice-zonghe.vue?vue&type=template&id=0f62925e&scoped=true&"
import script from "./practice-zonghe.vue?vue&type=script&lang=ts&"
export * from "./practice-zonghe.vue?vue&type=script&lang=ts&"
import style0 from "./practice-zonghe.vue?vue&type=style&index=0&id=0f62925e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62925e",
  null
  
)

export default component.exports